import { Header, Heading, Page, Text, ThemeType } from "grommet";
import { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { BSON } from "realm-web";
import { LoadingIndicator } from "../LoadingIndicator";
// import { AbuseGroups } from "../NewReport";
import { Updater } from "use-immer";
import { RealmContext } from "../providers/RealmProvider";
import { ThemeContext } from 'grommet/contexts/ThemeContext';

export type AbuseType = {
  label: string;
  xarf: string;
  name: string;
  heading: string;
  description: string;
};

export type AbuseFormConfig = Record<
  string,
  {
    linkText: string;
    link: string;
    support: string;
    title?: string;
    whiteLabeled?: boolean;
    stickyHeader?: boolean;
    fonts?: any;
    csam?: boolean;
  }
> & { global: { restrict?: boolean } } & { theme?: Record<string, any> };

export interface ClientConfig {
  _id: BSON.ObjectID;
  code: string;
  type: string;
  monitor: string[];
  name: string;
  abuseForm: AbuseFormConfig;
  abuseTypes: AbuseType[];
}

export const ClientConfigContext = createContext({} as ClientConfig);

export function ClientWrapper({ setTheme }: { setTheme: Updater<ThemeType> }) {
  const { user } = useContext(RealmContext);
  const params = useParams();
  const client = params.client! || ("" as string);

  const [config, setConfig] = useState<ClientConfig>({} as ClientConfig);
  const [error, setError] = useState<any>();
  const [themeAddOn, setThemeAddOn] = useState({});

  useEffect(() => {
    if (client === "" || !user) {
      return;
    }

    user
      .callFunction<ClientConfig>("getClientConfig", client)
      .then((config) => {
        if (!config.abuseForm.global) {
          config.abuseForm.global = {};
        }
        setThemeAddOn(config.abuseForm.theme || {});
        setError("");
        setConfig(config);
        document
          .getElementById("favicon")!
          .setAttribute(
            "href",
            `https://storage.googleapis.com/cleandns_public_images_and_logos/favicons/${config.code.toLocaleLowerCase()}.png`
          );
      })
      .catch(() => {
        setError(<>
          <Text>There was an error loading the abuse form configuration for the requested client: {client}.</Text>
          <Text>This may be a temporary error and you can try <a href="javascript:window.location.reload()">reloading this page</a>.</Text>
        </>);
      });
  }, [client, user]);

  if (error)
    return (
      <Page kind="narrow">
        <Header><Heading level={3}>Error</Heading></Header>
        {error}
      </Page>
    );

  if (!config.code) return <LoadingIndicator />;

  console.log(themeAddOn)

  return (
    <ThemeContext.Extend value={themeAddOn}>
      <ClientConfigContext.Provider value={config}>
        <Outlet />
      </ClientConfigContext.Provider>
    </ThemeContext.Extend>
  );
}
